export const C4SEAS_NAERLS_WEBSITE_URL = "https://c4seas-naerls-isfarm.vercel.app/";

export const NIGERIA_OFRA_CALIBRATION_TOOL_URL =
  "https://onedrive.live.com/:x:/g/personal/D81A254812272F8D/IQCdFLmOqy0sQLhIk6xkhc6yAdZGnz3tyo4JSX64AfyIFXY?resid=D81A254812272F8D!s8eb9149d2dab402cb84893ac6485ceb2&ithint=file%2Cxlsx&e=WBIOTX&migratedtospo=true&redeem=aHR0cHM6Ly8xZHJ2Lm1zL3gvYy9kODFhMjU0ODEyMjcyZjhkL0lRQ2RGTG1PcXkwc1FMaElrNnhraGM2eUFkWkduejN0eW80SlNYNjRBZnlJRlhZP2U9V0JJT1RY";

// External / contact links (UI-only; update these to your official project contacts when ready)
export const CONTACT_EMAIL = "s3asrgnigeria@gmail.com";
export const LINKEDIN_URL = "https://www.linkedin.com/in/s3asrg/";
export const YOUTUBE_URL = "https://www.youtube.com/@agrakadunaconsortium";
export const FACEBOOK_URL = "https://www.facebook.com/share/17VePV7vey/";

// Developer identity links for attribution and search visibility
export const DEVELOPER_GITHUB_URL = "https://github.com/Oyabure-Zakari";
export const DEVELOPER_X_URL = "https://x.com/OyabureZakari";
export const DEVELOPER_LINKEDIN_URL = "https://www.linkedin.com/in/zakari-oyabure-84933133b/";
